import React from 'react'

export function SegControl({ value, onChange, options, dark = false }) {
  return (
    <div style={{
      display: 'inline-flex',
      background: dark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.06)',
      borderRadius: 9,
      padding: 3,
      gap: 2
    }}>
      {options.map(o => {
        const isActive = value === o.key
        return (
          <button
            key={o.key}
            onClick={() => onChange(o.key)}
            style={{
              background: isActive ? '#007aff' : 'transparent',
              border: 'none',
              borderRadius: 7,
              padding: '5px 13px',
              fontSize: 12,
              fontWeight: 700,
              cursor: 'pointer',
              color: isActive ? '#ffffff' : (dark ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.6)'),
              boxShadow: isActive ? '0 1px 4px rgba(0, 122, 255, 0.25)' : 'none',
              transition: 'all 0.15s',
              fontFamily: 'inherit',
            }}
          >
            {o.label}
          </button>
        )
      })}
    </div>
  )
}
